

    <div class="row padding" [ngClass]="{'container': isMobileDevice()}" *ngIf="KeepRow?.length>0">
      <div class="col-sm-7">
        <h1 class="header">{{KeepRow[0]?.title}}</h1>
        <p class="content-text" [innerHtml]="KeepRow[0]?.description"></p>
      </div>
      <div class="col-sm-5 btn-productalign" (click)="scrollProduct('slideC')" style="float:right">
        <button color="accent" (click)="downloadFullProductCatalog();" mat-raised-button
          class="download-full-product buttonAlign">{{KeepRow[0].Button}}
          <img src="/assets/images/mobile/Major/Download_btn_icon.png" class="download-icon" />
        </button>
      </div>
    </div>
  <div *ngIf="isDownloadProduct" id="slideC" class="margin" 
    [ngClass]="{'downloadproductMobile': isMobileDevice() && websiteName == 'Major'  , 'downloadproduct': !isMobileDevice()}">
    <button mat-icon-button class="close-button" (click)="isDownloadProduct=!isDownloadProduct" >
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    <p class="b-align" style="color: #534848;">Let us know who you are so we can better serve you! </p>
    <!-- <br> -->
    <!-- <p class="content-text" style="margin-top: 10px;"> Understanding our site visitors allows us to personalize their
      experience and product offerings.</p> -->
   <b class="content-download" style="margin-top: 5px;">Select the option that best describes you to download the
      product catalog. </b>
  
    <div class="button-group">
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Current customer'}"
        value="Current customer" class="button">Current Customer
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Previous customer'}"
        value="Previous customer" class="button">Previous customer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Potential customer'}" value="Potential customer" class="button">Potential
        customer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Supplier Manufacturer'}" value="Supplier Manufacturer"
        class="button">Supplier/Manufacturer
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Consumer'}"
        value="Consumer" class="button">Consumer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Major Rugby Employee'}" value="Major Rugby Employee"
        class="button">Major Rugby Employee
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Other'}"
        value="Other" class="button">Other
      </button><br>
  
    </div>
    <div class="row">
  
      <div class="col-lg-4 mt-20 "  [ngClass]="{'btn-productalign' : isDesktopDevice(),'download-mobile':isMobileDevice()}">
        <button type="submit" mat-raised-button color="accent" id="btn-search" class="download-full-product buttonAlign"
          (click)="navigateToTargetLink(KeepRow[0])" [disabled]="!selectedRole"
          style="width: 100% !important;padding:2px !important;margin-top: 0px !important; margin-left: 0px !important;"
          matTooltip="Download Full Catalog" matTooltipClass="product-tool-tip" matTooltipPosition="right" color="accent"
          mat-raised-button>{{KeepRow[0].Button}}
          <!-- <span class="glyphicon glyphicon-download-alt black"></span> -->
          <img src="/assets/images/mobile/Major/Download_btn_icon.png" class="download-icon" />
        </button>
      </div>
      <div class="col-lg-8 mt-20 ">
        <img [ngStyle] ="{'padding-top' : isMobileDevice()?'10px' :''}" src="../../../../assets/images/Major/dark-gray circle.png" /><span class="spanAlign content ">
         Please select an option above to download the product catalog</span>
  
      </div>
    </div>
  
  </div>
  <div class="row keepAlign"  [ngClass]="{'container padding': isMobileDevice(),'padding-img keepleft':!isMobileDevice()}" *ngIf="KeepRow?.length>0">
  <div class="alignCenter">
    <h2 class="h1Title">{{KeepRow[1]?.title}}</h2>
    <span class="content" [innerHtml]="KeepRow[1]?.description"></span>
  </div>


<div class="cta-majorbtm-container" *ngIf=" websiteName == 'Major'"  >
  <div class=" alignCenter"  [ngClass]="{'cta-inner-container ': !isMobileDevice(), 'alignCenter':isMobileDevice()}"> 
     <!-- <div class="col-sm-2"></div>  -->
    <div *ngFor="let cta of KeepRow | slice:2; let i = index" class="cta-major-btm" >
     
      <img class="cta-btm-img"  (click)="navigateToTargetLink(cta)" src="{{cta.mediaUrl}}"  />
     
      <div class="major-btm-content" >
        <span class="cta-btm-title" >
          {{cta.title}}
        </span>  
        <br>
        <p class="content"   [innerHTML]="cta.description"></p>
        <!-- <span *ngIf="isMobileDevice()"><br></span> -->
        
        <button *ngIf="cta.Button" (click)="ctaClick(i, cta);" color="accent" class="buttonAlign" 
          mat-raised-button>{{cta.Button}}
          <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
        </button><br>
      </div>
     </div>   
   <div class="col-sm-2"></div> 

  </div>
</div>
</div>
 <div class="padding"  style="margin-top: 15px;" [ngClass]="{'container': isMobileDevice()}" *ngIf="LearnRow?.length>0">
  <h2 class="h1Title">{{LearnRow[0]?.title}}</h2>
  <p class="content" style="margin-top: -4px !important;padding-bottom: 15px !important;">{{LearnRow[0].description}}</p>
  <div class="grid-container">
    <div *ngFor="let category of LearnRow | slice:1;let i=index" 
      (click)="toggleCategory(category,i)" >
      <div class="category-box {{i}}" [class.active]="activeCatgeory===category.title" >
      <div #boxWrapper [ngStyle]="{'min-height': !isMobileDevice() ? category.minheight : 'auto'}">
      <div class="title" [ngStyle]="{'font-size' : isDesktopDevice() ? '16px':'12px'}">{{category.title}}
        <span class="activeCategory">
          <!-- {{category.expand?'x':'+'}} -->
          <img *ngIf="!category.expand" src="/assets/images/Major/Plus_btn_icon_blue.png"  class="plus-icon"/>
           <img  *ngIf="category.expand" src="/assets/images/Major/Close_btn_icon_blue.png" class="plus-icon" />
        </span>
      </div>
      <div *ngIf="category.expand" class="details {{i}}" >
       <span class="content-details" [innerHTML]="category.description"> </span>
      </div>
      </div>
      </div>
    </div>
  </div>
</div>
<div class="padding paddingBottom"  [ngClass]="{'container alignCenter': isMobileDevice()}" *ngIf="toBuy.length>0">
  <h2 style="margin-bottom: 2px;" class="h1Title" >{{toBuy[0].title}}</h2>
  <div *ngFor="let item of toBuy | slice:1;" >
 <div   style="margin-top: 10px !important;"><b  class="cta-btm-titleAlign">{{item.title}} - </b><span class="content" [innerHTML]="item.description"></span></div>
  </div>
  </div>


<div class="contact-us-container" style="display: none !important;">
  <div class="example-form">
    <div class="paddingfilter row" >
      <div class="col-sm-3">
        <mat-radio-group (change)="onProductChange($event)" *ngIf="isAuthenticated==false" name="productCatalogList"
          class="catalog-radio-group" id="product-catalog-list" color="primary">
          <mat-radio-button value="Current Customer" id="current-acnt"
            [checked]="productRadioButton=='Current Customer'">Current
            Customer&nbsp;</mat-radio-button><br />
          <mat-radio-button value="Previous Customer" id="previous-acnt" (change)="showDiv($event)"
            [checked]="productRadioButton=='Previous Customer'">Previous
            Customer&nbsp;</mat-radio-button><br />
          <mat-radio-button value="Potential New Customer" id="potential-customer-acnt" (change)="showDiv($event)"
            [checked]="productRadioButton=='Potential New Customer'">
            Potential New Customer&nbsp;</mat-radio-button><br />
            <mat-radio-button value="Supplier Manufacturer" id="supplier-manufacturer" (change)="showDiv($event)"
            [checked]="productRadioButton=='Supplier Manufacturer'">Supplier/Manufacturer</mat-radio-button>
            <br />
          <mat-radio-button value="Consumer" id="consumer" (change)="showDiv($event)"
            [checked]="productRadioButton=='Consumer'">Consumer</mat-radio-button>
          <br />
          <mat-radio-button value="Major Rugby Employee" id="major-rugby-emp" (change)="showDiv($event)"
          [checked]="productRadioButton=='Major Rugby Employee'">Major/Rugby Employee</mat-radio-button>
          <br />
          <mat-radio-button value="Other" id="other" (change)="showDiv($event)"
          [checked]="productRadioButton=='Other'">Other</mat-radio-button>
          <br />
        </mat-radio-group>
      </div>
      <div class="col-sm-3">
        <mat-radio-group *ngIf="isAuthenticated==false" name="productCatalogList2" class="catalog-radio-group"
          id="product-catalog-list2" color="primary">
          <mat-radio-button *ngIf="showCurrentCustomer" aria-posinset="right" value="currently_buy_products_on_major-rugby.com" id="buy-products-major"
            [checked]="productRadioButton=='buy_products_on_Major'" (change)="showDownloadBtn($event)">Currently buy
            products on
            major-rugby.com&nbsp;
          </mat-radio-button><br />
          <mat-radio-button *ngIf="showCurrentCustomer" value="currently_buy_products_through_Distributor/Wholesaler" id="buy-products-distributor"
            [checked]="productRadioButton=='buy_products_on_distributor'" (change)="showDownloadBtn($event)">Currently
            buy products through
            Distributor/Wholesaler&nbsp;</mat-radio-button><br />
        </mat-radio-group>
      </div>
    </div>

    <br>

    <div class="row">
      <div class="nav navbar-nav search-bar" *ngIf="!isAuthenticated && !showCurrentCustomer"
        (submit)="onSearchProductSubmit($event)" [disabled]="productsHideOrShow" hidden>
        <div class="navbar-form navbar-left search-fields" id="searchForm">
          <div class="col-lg-5">
            <input id="nav-search-text" type="search" [(ngModel)]="productSearch" placeholder="Search products"
              maxlength="100" (keyup.enter)="onSearchProductSubmit()" [matAutocomplete]="auto"
              [disabled]="searchBarDisabled" />
            <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
              <mat-option *ngFor="let option of productSuggestions" [value]="option">
                {{option | uppercase}}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <img src="/assets/images/search-magnifying-glass-icon.png" id="nav-search" class="search-icon"
          *ngIf="isAuthenticated==false" (click)="onSearchProductSubmit()" [disabled]="searchBarDisabled" />
      </div>
      <div class="row" hidden>
        <button type="submit" mat-raised-button color="primary" id="btn-search" [disabled]="productsHideOrShow"
          class="productSearch" (click)="getCTAContent($event)" *ngIf="isAuthenticated==false && !showCurrentCustomer"
          matTooltip="Download Full Catalog" matTooltipClass="product-tool-tip" matTooltipPosition="above">Full Product
          Catalog <span class="glyphicon glyphicon-download-alt"></span></button>
      </div>
    </div>
    <div class="col-lg-8 mt-20">
      <div class="row">
        <button type="submit" mat-raised-button color="primary" id="btn-search" class="btn-lg"
          (click)="getCTAContent($event)" *ngIf="isAuthenticated==false && downloadCatalog"
          matTooltip="Download Full Catalog" matTooltipClass="product-tool-tip" matTooltipPosition="right"
          style="height:100px; width:250px;">Full Product
          Catalog <span class="glyphicon glyphicon-download-alt black"></span></button>
      </div>
    </div>
    <div class="col-lg-6 mt-20" style="margin-bottom: 20px;" hidden>
      <div class="row">
        <div class="row col-lg-5">
          <div (click)="doFilter('O')" class="catalog-link ">
            <div class="catalog-card" *ngIf="isHidden" [ngClass]="{'catalog-card-active': catalogFilterBy === 'O'}">
              <div class="catalog-card-body">
                <h4 class="catalog-header" style="margin-bottom: 10px;">OTC Products</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div (click)="doFilter('R')" class="catalog-link ">
            <div class="catalog-card" *ngIf="isHidden" [ngClass]="{'catalog-card-active': catalogFilterBy === 'R'}">
              <div class="catalog-card-body">
                <h4 class="catalog-header" style="margin-bottom: 10px;">RX Products</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>
  </div>
  <div class="col-lg-12"></div>
  <par-product-search-unauth>

  </par-product-search-unauth>
</div>